import mainService from "./authService";

export function processCheckout(data) {
    return mainService
        .post("/process-checkout", data)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

export function processPayment(data) {
    return mainService
        .post("/process-payment", data)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

export function setCustomerSubscription(data) {
    return mainService
        .post("/set-customer-subscription", data)
        .then(res => {
            return res;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}


// WEBPACK FOOTER //
// ./src/services/checkout.js